import imageCompression, { Options } from 'browser-image-compression'

export async function resizeImage(file: File, customOptions?: Options) {
  return imageCompression(file, {
    maxSizeMB: 2, // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 1000, // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    // fileType: 'image/webp', // optional, fileType override e.g., 'image/jpeg', 'image/png' (default: file.type)
    ...customOptions,
  })
}
